import * as Sentry from "@sentry/react";
import { env } from "./env";
import React from "react";
import "./index.css";
import { createRoot } from "react-dom/client";
import { PosconStage } from "@poscon/shared-frontend";
import { store } from "~redux/store";
import { Provider } from "react-redux";
import { Stars } from "./components/Stars";
import { Assets } from "pixi.js";

Sentry.init({
  dsn: env.VITE_SENTRY_URL_STARS,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
  ],
  sampleRate: 1,
  // Tracing
  tracesSampleRate: 0.001,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["hq.poscon.local", "https://nas.poscon.com"],
  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 0.1,
});

await Assets.load([
  "/fonts/starsTargetSymbols1.xml",
  "/fonts/starsText0.xml",
  "/fonts/starsText1.xml",
  "/fonts/starsText1_outlined.xml",
  "/fonts/starsText2.xml",
  "/fonts/starsText2_outlined.xml",
  "/fonts/starsText3.xml",
  "/fonts/starsText3_outlined.xml",
  "/fonts/starsText4.xml",
  "/fonts/starsText4_outlined.xml",
  "/fonts/starsText5.xml",
  "/fonts/starsText5_outlined.xml",
  "/fonts/starsText6.xml",
  "/fonts/starsText6_outlined.xml",
]);

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
  <React.StrictMode>
    <div id="eramRoot" className="root" onContextMenu={(e) => e.preventDefault()}>
      <PosconStage>
        <Provider store={store}>
          <Stars />
        </Provider>
      </PosconStage>
    </div>
  </React.StrictMode>,
);
